<template>
  <div @click="onClose" id="sideBarModalComponent" class="wrapper">
    <div :class="{wrapper_body: true, open: true}">
      <div class="loading_div" v-if="loading">
        <pulse-loader :loading="loading" :color="color" class="text-center"/>
      </div>
      <div class="editBlock p-2" v-else>
        <Profile
          :updateRecord="updateRecord"
          :closeProfile="() => onClose(null, true)"
          :managers="managers"
          :user="originalUser"
          :roles="roles"
          :tags="tags"
        />
      </div>
    </div>
  </div>
</template>

<script>

import api from '@/api'
import Profile from '@/views/users/Profile'

export default {
  components: {
    Profile
  },
  props: ['modalData', 'onModalClose', 'user', 'roles', 'tags', 'updateRecord'],
  data() {
    return {
      color: '#5BBFDE',
      loading: true,
      originalUser: null,
      managers: {},
    }
  },
  mounted() {
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = "hidden";
    this.getUser();
  },
  methods: {
    disableLoading() {
      this.loading = false;
    },
    async getUser() {
      const {data} = await api.index('/users/edit/' + this.user.id);
      if (data.success) {
        this.managers = data.managers;
        this.originalUser = data.user;
        this.loading = false;
      } else {
        toastr['warning'](data.message || 'Ошибка сервера');
      }
    },
    onClose(e, global = false) {
      if (global || e && e.target && e.target.id === 'sideBarModalComponent') {
        // if (e.target.id === 'sideBarModalComponent') {
        const body = document.getElementsByTagName('body')[0];
        body.style.overflow = "auto";
        setTimeout(() => {
          this.onModalClose();
        }, 200);
      }
    }
  }
}

</script>

<style>
.sideBarModalComponent {

}
</style>

<style scoped>
.editBlock .main-content {
  padding: 0;
}

.loading_div {
  position: absolute;
  top: 50%;
  left: 50%;
}

.wrapper_body.open {
  /*left: calc(100% - 300px);*/
  left: 25%;
  transition: all 0.3s ease 0s;
}

.wrapper_body {
  position: relative;
  transition: all 0.3s ease 0s;
  /*background-color: white;*/
  background-color: #f8f8f8;
  width: 75%;
  left: 100%;
  min-height: 100%;
  z-index: 9999;
}

.wrapper {
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  position: fixed;
  overflow-x: hidden;
  overflow-y: auto;
  z-index: 9999;
  transition: all 0.3s ease 0s;
  background-color: rgba(0, 0, 0, 0.5);
}
</style>
